<template>
    <view-container v-if="isReady" :headline="isCreate ? '안심계약 생성' : '안심계약 상세'" :maxWidth="'1440px'">
        <div class="text-h6 text-start mt-8">기본정보</div>
        <!-- 고객 / 담당자 -->
        <meta-data v-model="contract.meta" :measurers="measurers" />
        <!-- 계약정보 -->
        <contract v-model="contract" :disabled="!isCreate" />

        <v-tabs v-model="currentTab" class="mt-5" background-color="transparent" :style="{ display: isCreate ? 'none' : 'block' }">
            <v-tab href="#tab-contract">계약내용</v-tab>
            <v-tab href="#tab-payments">결제내역</v-tab>
        </v-tabs>

        <v-tabs-items v-model="currentTab" style="background-color:transparent">
            <v-tab-item value="tab-contract">
                <div class="text-h6 text-start mt-8">표준계약서</div>
                <v-row>
                    <v-col>
                        <!-- 고객정보 -->
                        <employer v-model="document.employer" :employer="contract.meta.employer" :disabled="!isCreate" />
                        <!-- 대리점정보 -->
                        <employee v-model="document.employee" :interiors="interiors" :disabled="!isCreate" />
                        <!-- 날짜정보 -->
                        <dates v-model="document" :disabled="!isCreate" />
                    </v-col>
                    <v-col>
                        <!-- 공사금액정보 -->
                        <payment-plan v-model="document.paymentPlan" :disabled="!isCreate" />
                    </v-col>
                </v-row>

                <div class="text-h6 text-start mt-8">결제기본정보</div>
                <v-row>
                    <v-col>
                        <!-- 가상계좌정보 -->
                        <payment-bank-account v-model="contract" />
                    </v-col>
                    <v-col>
                        <!-- 결제증빙정보 -->
                        <tax-proof v-model="contract.taxProof" />
                    </v-col>
                </v-row>

                <div class="text-h6 text-start mt-8">계약내용</div>

                <v-row>
                    <v-col>
                        <terms-basic />
                    </v-col>
                    <v-col>
                        <terms-special v-model="document" :readonly="!isCreate" />
                    </v-col>
                </v-row>

                <div v-if="!isCreate" class="text-h6 text-start mt-8">계약상태</div>
                <v-row>
                    <v-col>
                        <!-- 계약서 목록 -->
                        <documents
                            v-if="!isCreate"
                            :documents="contract.documents"
                            @clickNewDocument="$refs['popup-add-document'].open(document)"
                            @clickShowDocument="(_id) => $refs['popup-show-document'].open(_id)"
                        />
                    </v-col>
                </v-row>
            </v-tab-item>
            <v-tab-item value="tab-payments">
                <div class="text-h6 text-start mt-8">결제계약정보</div>
                <v-row>
                    <v-col>
                        <payment-plan v-model="document.paymentPlan" :disabled="!isCreate" />
                    </v-col>
                    <v-col>
                        <payment-bank-account v-model="contract" />
                        <tax-proof v-model="contract.taxProof" />
                    </v-col>
                </v-row>

                <div class="text-h6 text-start mt-8">입금내역</div>
                <v-row>
                    <v-col>
                        <payments :paymentPlan="document.paymentPlan" v-model="contract" />
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs-items>

        <!-- 신규계약 생성 버튼 -->
        <v-row justify="center" v-if="isCreate && isConsole">
            <v-col cols="auto">
                <v-btn color="primary" @click="save()">계약서생성 및 알림발송</v-btn>
            </v-col>
        </v-row>

        <popup-add-document ref="popup-add-document" :interiors="interiors" @save="save" />
        <popup-show-document ref="popup-show-document" :contract="contract" />

        <v-btn v-if="!isCreate && isConsole" bottom color="accent" fixed right @click="save()"> <v-icon class="mr-2">mdi-content-save</v-icon> 수정사항 저장 </v-btn>
    </view-container>
</template>
<script>
import api from "@/api";

import ViewContainer from "@/components/console/dumb/view-container.vue";
import MetaData from "@/components/console/contracts/meta-data.vue";
import Employer from "@/components/console/contracts/employer.vue";
import Employee from "@/components/console/contracts/employee.vue";
import Contract from "@/components/console/contracts/contract.vue";
import Dates from "@/components/console/contracts/dates.vue";
import PaymentPlan from "@/components/console/contracts/payment-plan.vue";
import PaymentBankAccount from "@/components/console/contracts/payment-bank-account.vue";
import TaxProof from "@/components/console/contracts/tax-proof.vue";
import Documents from "@/components/console/contracts/documents.vue";
import PopupAddDocument from "@/components/console/contracts/popup-add-document.vue";
import PopupShowDocument from "@/components/console/contracts/popup-show-document.vue";

import initialDocument from "@/assets/data/initialContractDocument.json";
import TermsBasic from "@/components/console/contracts/terms-basic.vue";
import TermsSpecial from "@/components/console/contracts/terms-special.vue";
import Payments from "@/components/console/contracts/payments.vue";

const initialContract = {
    // _id: null,
    _inquiry: null, // 견적요청서
    _employer: null, // 고객
    _employee: null, // 업체

    contractNumber: null, // 계약번호
    isWhole: null, // 계약형태 : ( true = 종합인테리어 || false = 부분인테리어 )
    _virtualAccount: null, // 가상계좌

    // 기본정보
    meta: {
        employer: {
            name: null,
            phone: null,
            address: null,
        },

        measurer: {
            _user: null,
            consultationLocation: null,
        },
    },

    documents: [], // 계약서

    payments: [
        // {
        //     amount: Number, // 입금액
        //     wiredAt: Date, // 입금날짜
        //     isManuallyInput: Boolean, // true: 수동입력, false: 가상계좌 자동입력
        //     isTaxInvoiced: Boolean, // 세금계산서발행 여부
        //     isPaymentSettled: String, // 업체정산 여부 ["정산완료","정산전","미정산"]
        //     memo: String, // 관리자 메모
        //     meta: {
        //         bankName: String, // 입금 은행명
        //         accountHolder: String, // 입금주
        //         accountNumber: String, // 입금계좌
        //     },
        // },
    ],

    taxProof: {
        type: null, // 현금영수증 || 세금계산서 || 미발급
        data: [
            // {
            //     key: null, // issuanceNumber || identificationNumber || email
            //     value: null, // value of above
            // },
        ], // 현금영수증발급번호 || 주민등록번호 또는 사업자등록번호 || null
    },
    // createdAt: null,
    // updatedAt: null,
};

export default {
    components: {
        ViewContainer,
        MetaData,
        Employer,
        Employee,
        Contract,
        Dates,
        PaymentPlan,
        PaymentBankAccount,
        TaxProof,
        Documents,
        PopupAddDocument,
        PopupShowDocument,
        TermsBasic,
        TermsSpecial,
        Payments,
    },
    data() {
        return {
            isReady: false,
            isCreate: false,
            currentTab: 0,
            contract: {},
            document: {},
            measurers: [],
            interiors: [],
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            let { _contract: _id } = this.$route.params;

            try {
                if (_id) {
                    // 계약서 열람
                    const { contract } = await api.console.contracts.getContract({ _id });
                    this.contract = contract;
                    this.document = contract.documents[contract.documents.length - 1];

                    if (this.isConsole) {
                        const { users: interiors } = await api.console.users.getUsers({ params: { scope: "interior" } });
                        this.interiors = interiors;
                    }
                } else {
                    // 계약서 생성
                    let { _inquiry } = this.$route.query;
                    if (_inquiry) {
                        // 견적신청 문서가 있을 시
                        const { inquiry } = await api.console.estimate.inquiries.getInquiry({ _id: _inquiry });

                        this.contract = {
                            ...initialContract,

                            _inquiry, // 견적요청서
                            _employer: inquiry._user, // 고객
                            _employee: inquiry._interior, // 업체

                            contractNumber: null, // 계약번호
                            isWhole: inquiry.measurementInfo.isWhole, // 계약형태 : ( true = 종합인테리어 || false = 부분인테리어 )

                            // 기본정보
                            meta: {
                                employer: {
                                    name: inquiry.name,
                                    phone: inquiry.phone,
                                    address: `${inquiry.address1}, ${inquiry.address2}`, // 시공지 주소
                                },
                                measurer: {
                                    ...initialContract.meta.measurer,
                                    _user: inquiry.measurementInfo._measurer,
                                },
                            },
                        };

                        this.document = {
                            ...initialDocument,

                            // 계약서

                            employee: {
                                _user: inquiry._interior,
                                businessName: inquiry.interior.meta.companyName,
                                businessNumber: inquiry.interior.meta.businessNumber,
                                address: `${inquiry.interior.address1}, ${inquiry.interior.address2}`,
                                name: inquiry.interior.name, // 대표자 이름
                                phone: inquiry.interior.phone.phoneNumberFormat(), // 전자인증용 연락처
                            },
                        };

                        this.interiors = inquiry.interiors;
                    } else {
                        // 견적요청 문서가 없을 시
                        const { users: interiors } = await api.console.users.getUsers({ params: { scope: "interior" } });

                        this.contract = { ...initialContract };
                        this.document = { ...initialDocument };

                        this.interiors = interiors;
                    }

                    this.isCreate = true;
                }

                // 담당직원 (measurers)
                const { users: measurers } = await api.console.users.getUsers({ params: { scope: "measurer" } });
                this.measurers = measurers;

                this.isReady = true;
            } catch (error) {
                this.handleError(error);
            }
        },
        async save(document) {
            try {
                if (this.isCreate || document) this.validate(document ? document : this.document);

                if (this.isCreate) {
                    // 안심계약 생성 및 계약서 생성
                    const { contract } = await api.console.contracts.postContract({ contract: { ...this.contract, _employee: this.document.employee._user }, document: this.document });
                    await this.$router.push(`/console/contracts/${contract._id}`);
                    alert("안심계약이 생성되었습니다.");
                } else if (document) {
                    // 수정계약서 생성
                    const { contractDocument } = await api.console.contracts.postContractDocument({
                        ...document,
                        contract: this.contract._id,
                        contractNumber: this.contract.contractNumber,
                    });
                    console.log({ contractDocument });
                    await api.console.contracts.putContract({ _id: this.contract._id, _documents: [...this.contract._documents, contractDocument._id] });
                    this.$refs["popup-add-document"].close();
                    alert("계약서가 생성되었습니다.");
                } else {
                    // 안심계약 수정
                    const { _id, meta, taxProof } = this.contract;
                    await api.console.contracts.putContract({ _id, meta, taxProof });
                    alert("안심계약이 수정되었습니다.");
                }

                // 페이지 리로드
                this.$router.go();
            } catch (error) {
                this.handleError(error);
            }
        },
        async test() {
            try {
                await api.console.contracts.test(this.contract);
            } catch (error) {
                this.handleError(error);
            }
        },
        validate(document) {
            if (this.contract.isWhole == null) throw new Error("계약형태가 입력되지 않았습니다.");

            if (!document?.employer?.name) throw new Error("고객 성명이 입력되지 않았습니다.");
            if (!document?.employer?.phone) throw new Error("고객 인증연락처가 입력되지 않았습니다.");
            if (!document?.employer?.address) throw new Error("고객 시공지주소가 입력되지 않았습니다.");
            if (!document?.employee?.businessName) throw new Error("대리점 상호가 입력되지 않았습니다.");
            if (!document?.employee?.businessNumber) throw new Error("대리점 사업자등록번호가 입력되지 않았습니다.");
            if (!document?.employee?.address) throw new Error("대리점 주소가 입력되지 않았습니다.");
            if (!document?.employee?.name) throw new Error("대리점 대표자명이 입력되지 않았습니다.");
            if (!document?.employee?.phone) throw new Error("대리점 인증연락처가 입력되지 않았습니다.");
            if (!document?.startsAt) throw new Error("공사시작일이 입력되지 않았습니다.");
            if (!document?.endsAt) throw new Error("공사종료일이 입력되지 않았습니다.");
            if (!document?.signsAt) throw new Error("계약일이 입력되지 않았습니다.");
            if (!document?.paymentPlan?.length) throw new Error("공사금액이 입력되지 않았습니다.");

            for (const payment of document.paymentPlan) {
                if (!payment.type) throw new Error("잘못된 요청입니다.");
                if (!payment.amount) throw new Error("공사금액이 입력되지 않았습니다.");
                if (!payment.duesAt) throw new Error("공사금액 납입일이 입력되지 않았습니다.");
            }
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        _user() {
            return this.payload._user;
        },
        isConsole() {
            return this.scope.includes("console");
        },
        isInterior() {
            return this.scope.includes("interior");
        },
    },
};
</script>
